import koubraAkhounaPicture from '../../assets/contact/koubra_akhouna.png';
import fannyTerrisPicture from '../../assets/contact//fanny_terris.png';
import hugoDavoutPicture from '../../assets/contact//hugo_davout.png';
import raphaelleAtlaniPicture from '../../assets/contact//raphaelle_atlani.png';
import isabelleAzoulaiPicture from '../../assets/contact//isabelle_azoulai.jpg';
import romainPicture from '../../assets/contact//romain.png';
import pierreAntoineNonotteVarlyPicture from '../../assets/contact//pierre_antoine_nonotte_varly.jpg';
import defaultPicture from '../../assets/contact//default.png';

const useInvestContactPicture = (pictureTag: string) => {
	switch (pictureTag) {
		case 'fanny_terris':
			return fannyTerrisPicture;
		case 'koubra_akhouna':
			return koubraAkhounaPicture;
		case 'raphaelle_atlani':
			return raphaelleAtlaniPicture;
		case 'hugo_davout':
			return hugoDavoutPicture;
		case 'isabelle_azoulai':
			return isabelleAzoulaiPicture;
		case 'romain_jouvene':
			return romainPicture;
		case 'pierre_antoine_nonotte_varly':
			return pierreAntoineNonotteVarlyPicture;
		default:
			return defaultPicture;
	}
};

export default useInvestContactPicture;
